import { type IconType } from "..";

const AccommodationIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19.4 26.4"
      className={`${props.size}`}
      {...props}
    >
      <path
        className={`${fill}`}
        d="M1 25.5h17.5L16 11v-.4c0-.1.2-.2.3-.2h2l-.4-2.7-3.7-2.5c-.3-.2-.7-.3-1-.3h-.8c.1.3.2.6.2.9 0 1.5-1.4 2.8-3 2.8s-3-1.3-3-2.8 0-.6.2-.9H6c-.4 0-.7.1-1 .3-.2.1-2.2 1.5-3.6 2.5L1 10.4h2c.1 0 .3 0 .3.1s.1.2 0 .4L1 25.5Zm18 .9H.4c-.1 0-.3 0-.3-.2 0-.1-.1-.2 0-.4l2.5-14.5H.5c-.1 0-.3 0-.3-.1 0 0-.1-.2-.1-.4l.5-3.4c0-.1 0-.2.2-.3 2.4-1.7 3.4-2.3 3.8-2.6.5-.4 1-.5 1.5-.5h1.6c.2 0 .3.1.4.3v.5c-.3.3-.4.7-.4 1.1 0 1.1 1 1.9 2.2 1.9s2.2-.9 2.2-1.9-.1-.8-.4-1.1c-.1-.1-.1-.3 0-.5 0-.2.2-.3.4-.3h1.6c.5 0 1 .2 1.5.5L19 7.1c.1 0 .2.2.2.3l.5 3.4c0 .1 0 .3-.1.4 0 0-.2.2-.3.2h-2l2.5 14.5v.4c0 .1-.2.2-.3.2"
      />
      <path
        className={`${fill}`}
        d="M14.6 6.2c-.2 0-.4-.2-.4-.4V3.2c0-.2.2-.4.4-.4s.4.2.4.4v2.6c0 .2-.2.4-.4.4M4.9 6.2c-.2 0-.4-.2-.4-.4V3.2c0-.2.2-.4.4-.4s.4.2.4.4v2.6c0 .2-.2.4-.4.4"
      />
      <path
        className={`${fill}`}
        d="M14.2 2.7h.8V1.3h-.8v1.4Zm1.2.9h-1.7c-.2 0-.4-.2-.4-.4V.8c0-.2.2-.4.4-.4h1.7c.2 0 .4.2.4.4v2.3c0 .2-.2.4-.4.4M4.5 2.7h.8V1.3h-.8v1.4Zm1.2.9H4c-.2 0-.4-.2-.4-.4V.8c0-.2.2-.4.4-.4h1.7c.2 0 .4.2.4.4v2.3c0 .2-.2.4-.4.4"
      />
      <path
        className={`${fill}`}
        d="M9.7 2.3c-1.4 0-2.8 0-4.1-.2-.2 0-.4-.2-.4-.4v-.4h-.8c0 .2 0 .4-.2.5-.1 0-.2.1-.4 0-1.3-.2-2.4-.6-3.3-1C.3.8.2.4.3.2.5 0 .7 0 1 0c.7.3 1.6.6 2.6.8 0-.3.2-.5.4-.5h1.7c.2 0 .4.2.4.4v.4c2.3.3 4.9.3 7.2 0V.7c0-.2.2-.4.4-.4h1.7c.2 0 .4.2.4.4 1-.2 1.9-.5 2.6-.8.2 0 .5 0 .6.2 0 .2 0 .5-.2.6-.9.4-2 .7-3.3 1h-.4c-.1 0-.2-.2-.2-.3 0-.1-.8-.1-.8-.1v.4c0 .2-.2.4-.4.4-1.3.2-2.7.2-4.1.2"
      />
    </svg>
  );
};

export default AccommodationIcon;
